/**
 * Builds the relative path of the photo-measure page deep link (`measure?d=…&t=…&collection=…`).
 * Single source of truth for the link format, shared by the client (PhotomeasureButton, which uses
 * it as-is) and server-side exports that embed absolute links (SpidaCalc `officeProUrl`, which
 * prepends `${applicationUrl}/#/`). Param names must match the `QueryParams` contract of
 * `PhotoMeasurePageConfig` (`path: '/measure'`) in client-ui.
 */
export function buildMeasurePath(departmentId: string, tagId: string, collectionUuid?: string | null): string {
	const path = `measure?d=${encodeURIComponent(departmentId)}&t=${encodeURIComponent(tagId)}`;
	return collectionUuid == null ? path : `${path}&collection=${encodeURIComponent(collectionUuid)}`;
}
